import { gsap } from "gsap";
import { checkDeviceMobile } from "../../../libs/helper";
import EmitEvent, { BACK_TOP } from "../../../libs/emit-event";

export class BackTop {
  constructor() {
    this.DOM = { el: document.querySelector(".js-btnBack") };
    if (!this.DOM.el) return;
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.init();
    this.bindEvent();
  }

  init() {
    this.DOM.img = this.DOM.el.querySelector(".js-btnBack_icon_img");

    this.DOM.imgClone = this.DOM.img.cloneNode(true);
    this.DOM.imgClone.classList.add("is-clone");
    gsap.set(this.DOM.imgClone, { y: "102%" });
    this.DOM.img.parentElement.append(this.DOM.imgClone);
  }

  onMouseEnter() {
    gsap.killTweensOf(this.DOM.img);
    gsap.killTweensOf(this.DOM.imgClone);

    gsap.fromTo(
      this.DOM.img,
      { y: "0%" },
      { y: "-102%", duration: 0.5, ease: "power3.out" }
    );
    gsap.fromTo(
      this.DOM.imgClone,
      { y: "102%" },
      { y: "0%", duration: 0.5, ease: "power3.out", delay: 0.1 }
    );
  }

  onClick(e) {
    e.preventDefault();
    if (checkDeviceMobile()) {
      gsap.to(window, {
        scrollTo: { y: 0 },
        ease: "power3.inOut",
        duration: 1.2,
      });
    } else {
      EmitEvent.emit(BACK_TOP);
    }
  }

  bindEvent() {
    if (!checkDeviceMobile()) {
      this.DOM.el.addEventListener("mouseenter", this.onMouseEnter);
    }
    this.DOM.el.addEventListener("click", this.onClick);
  }
}
